




































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { OpenAccountParams, BankItem } from '@/api/model/account'
import $Api from '@api'
import { translate } from '@/utils/filters'
import FormValidator from '@/utils/form-validator'

@Component
export default class AddForm extends Vue {
    formValidator = new FormValidator()
    formData: OpenAccountParams = {} as OpenAccountParams

    @Prop()
    isShownDialog!: boolean

    @Prop({ default: false })
    isEdit!: boolean

    @Prop()
    dialogFormData!: any

    @Watch('dialogFormData', { deep: true })
    onDialogFormDataChange(data: any): void {
        this.formData = { ...data }
    }

    currencyOptions: { label: string; value: string }[] = [
        {
            value: 'CNY',
            label: 'CNY'
        },
        {
            value: 'USD',
            label: 'USD'
        },
        {
            value: 'VND',
            label: 'VND'
        },
        {
            value: 'PHP',
            label: 'PHP'
        },
        {
            value: 'MXN',
            label: 'MXN'
        },
        {
            value: 'IDR',
            label: 'IDR'
        },
        {
            value: 'INR',
            label: 'INR'
        }
    ]

    bankOptions: { label: string; value: string | number }[] = []

    formProperty = {
        accountInfoName: {
            prop: 'accountInfoName',
            rules: [{ required: true, message: translate('nav.account.company.formData.error.accountName.required'), trigger: 'blur' }]
        },
        currency: {
            prop: 'currency',
            rules: [{ required: true, message: translate('nav.account.company.formData.error.currency.required'), trigger: 'blur' }]
        },
        balance: {
            prop: 'balance'
        },
        cardNumber: {
            prop: 'cardNumber'
        },
        bankId: {
            prop: 'bankId'
        },
        phone: {
            prop: 'phone',
            rules: [{ validator: this.formValidator.mobile(), trigger: 'blur' }]
        },
        email: {
            prop: 'email',
            rules: [{ validator: this.formValidator.mail(), trigger: 'blur' }]
        },
        state: {
            prop: 'state'
        }
    }

    get dialogTitle(): string {
        return this.isEdit ? translate('nav.account.company.formData.editTitle') : translate('nav.account.company.formData.addTitle')
    }

    mounted(): void {
        this.getBankList()
    }

    getBankList(): void {
        $Api.accountService.getBankList().subscribe(data => {
            if (Array.isArray(data)) {
                this.bankOptions = data.map((bank: BankItem) => {
                    return { label: bank.bankName, value: bank.id }
                })
            }
        })
    }

    add(): void {
        ;(this.$refs['dialogForm'] as Form).validate(valid => {
            if (valid) {
                this.openAccountSubmit()
            }
        })
    }

    openAccountSubmit(): void {
        const { accountInfoId, id, accountInfoName, balance, bankId, cardNumber, currency, email, phone, state } = this.formData
        const bank = this.bankOptions.find(bank => bank.value === bankId)
        const bankName = bank && bank.label

        let params: OpenAccountParams = {
            type: 1,
            cardType: 1,
            name: accountInfoName as string,
            accountInfoName,
            balance,
            bankName,
            bankId,
            cardNumber,
            currency,
            email,
            phone,
            state
        }

        if (this.isEdit) {
            params = { accountInfoId, id, ...params }
        }

        $Api.accountService.openAccount(params).subscribe(
            res => {
                this.$message({
                    message: translate('common.success'),
                    type: 'success'
                })
                this.handleClose({ isRefresh: true })
            },
            err => {
                this.$notify.error(err.message)
            }
        )
    }

    handleClose({ isRefresh }): void {
        if (isRefresh) {
            this.$emit('refresh')
        }
        this.$emit('close')
        this.reset('dialogForm')
    }

    reset(formName: string): void {
        ;(this.$refs[formName] as Form).resetFields()
    }
}
